module.exports = __webpack_public_path__ + "img/cognitive_img04.61a0b583.png";